import { Injectable } from '@angular/core';
import { APP_CONFIG } from '../../shared/common/config';
import { HttpClient } from '@angular/common/http';
import { FXResponse } from '../../models/response.model';
import { MapUtils } from '../../shared/utils/mapper';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DUMMY_DATA } from '../../shared/utils/data';
import { BonusSettingModel } from '../../models/bonus-setting.model';
import { standardizeParam } from '../../shared/utils/helper';
import { BonusDepositModel, BonusManualModel } from '../../models/bonus-manual.model';
import { BaseResponse } from '../../models/shared.interface';
import { PreviewEmailsRequestProps, PromotionCodeHistory, PromotionProps, SentStatusMailResponse } from './promotion/promotion-bonus.type';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BonusService {
  private bonusUrl = APP_CONFIG.BASE_API_LINK.BONUS_SETTING;
  previewMailData: PromotionProps;
  constructor(private http: HttpClient) {}

  getSettingBonus(type:string): Observable<FXResponse<BonusSettingModel>> {
    const url = `${this.bonusUrl}/permanent/`+type;
    return this.http
      .get(url)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          response.data = res.data;
          return res;
        }),
      );
  }
  //bonus permanent
  updatePermanentBonus(bonus: any): Observable<any> {
    const url = `${this.bonusUrl}/permanent`;
    const jsonBonus = MapUtils.serialize(bonus);
    return this.http.put(url, jsonBonus).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  updateSettingBonus(bonus: any): Observable<any> {
    const url = `${this.bonusUrl}/bonus-setting`;
    const jsonBonus = MapUtils.serialize(bonus);
    return this.http.put(url, jsonBonus).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  // manual history
  getBonusManualHistory(params): Observable<FXResponse<any>> {
    const url = `${this.bonusUrl}/bonus-manual?${standardizeParam(params)}`;
    return this.http
      .get(url)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          const  listManual = res.data.manual_bonus.map(v =>
            MapUtils.deserialize(BonusManualModel, v));
          response.data = listManual;
          response.paging = res.data.paging;
          return response;
        }),
      );
  }
  updateBonusManualAmount(form: any): Observable<any> {
    const url = `${this.bonusUrl}/bonus-manual`;
    const jsonBonus = MapUtils.serialize(form);
    return this.http.put(url, jsonBonus).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  // manual history
  getBonusDepositHistory(params): Observable<FXResponse<any>> {
    const url = `${this.bonusUrl}/bonus-setting/deposit?${standardizeParam(params)}`;
    return this.http
      .get(url)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          response.data = res.data.deposit_bonus_configs.map(v =>
            MapUtils.deserialize(BonusDepositModel, v));
          response.paging = res.data.paging;
          return response;
        }),
      );
  }
  createBonusDeposit(form: any): Observable<any> {
    const url = `${this.bonusUrl}/bonus-setting/deposit`;
    return this.http.post(url, form).pipe(
      map((res: any) => {
        return  new FXResponse<any>().deserialize(res);
      })
    );
  }

  // Top 5 loss cut
  getBonusLossCutHistory(params): Observable<FXResponse<any>> {
    return new Observable<FXResponse<any[]>>((observer) => {
      const res: any = DUMMY_DATA.BONUS.LOSS_CUT_HISTORY;
      observer.next(res);
      observer.complete();
    }).pipe(
      map((res: any) => {
        const response = new FXResponse<any[]>().deserialize(res);
        return response;
      })
    );
  }
  // Profit and Loss
  getBonusProfitLossHistory(params): Observable<FXResponse<any>> {
    return new Observable<FXResponse<any[]>>((observer) => {
      const res: any = DUMMY_DATA.BONUS.PROFIT_AND_LOSS_HISTORY;
      observer.next(res);
      observer.complete();
    }).pipe(
      map((res: any) => {
        const response = new FXResponse<any[]>().deserialize(res);
        return response;
      })
    );
  }
  getHistoryMT4Transactions(params: any): Observable<FXResponse<any[]>> {
    return this.http
      .get(
        `${
          APP_CONFIG.BASE_API_LINK.BONUS_SETTING
          }/bonus-manual-history?${standardizeParam(params)}`
      )
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any[]>().deserialize(res);
          return response;
        })
      );
  }

  // code history
  getBonusCodeHistory(params): Observable<BaseResponse<PromotionCodeHistory>> {
    const url = `${this.bonusUrl}/events?${standardizeParam(params)}`;
    return this.http.get<BaseResponse<PromotionCodeHistory>>(url);

  }
  getByCodeBonusSetting(code): Observable<BaseResponse<PromotionCodeHistory>> {
    const url = `${this.bonusUrl}/events/detail/${code}`;
    return this.http.get<BaseResponse<PromotionCodeHistory>>(url);
  }
  // search level 1 by name
  searchLevelOneByName(params): Observable<FXResponse<any>> {
    const url = `${this.bonusUrl}/events/searching?${standardizeParam(params)}`;
    return this.http
      .get(url)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          response.data = res.data.level1_ibs;
          return response;
        }),
      );
  }
  // get rate
  getRateBySymbol(params): Observable<FXResponse<any>> {
    const url = `${this.bonusUrl}/events/rate?${standardizeParam(params)}`;
    return this.http
      .get(url)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          response.data = res.data;
          return response;
        }),
      );
  }
  // get event children
  getEventChildren(params): Observable<FXResponse<any>> {
    const url = `${this.bonusUrl}/events/children-email?${standardizeParam(params)}`;
    return this.http
      .get(url)
      .pipe(
        map((res: any) => {
          const response = new FXResponse<any>().deserialize(res);
          response.data = res.users;
          return response;
        }),
      );
  }
  createBonusEvents(form: any): Observable<any> {
    const url = `${this.bonusUrl}/events`;
    return this.http.post(url, form).pipe(
      map((res: any) => {
        return  new FXResponse<any>().deserialize(res);
      })
    );
  }
  updateBonusEvents(id:number,form: any): Observable<any> {
    const url = `${this.bonusUrl}/events/edit/${id}`;
    return this.http.post(url, form).pipe(
      map((res: any) => {
        return  new FXResponse<any>().deserialize(res);
      })
    );
  }
  updateModeEvents(form: any): Observable<any> {
    const url = `${this.bonusUrl}/events`;
    return this.http.put(url, form).pipe(
      map((res: any) => {
        return  new FXResponse<any>().deserialize(res);
      })
    );
  }

  updateIbSettings(body): Observable<any> {
    return this.http.put<any>(`${this.bonusUrl}/permanent`, body);
  }


  getPreviewMailTemplate(body: PreviewEmailsRequestProps): Observable<any> {
    return this.http.post(`${this.bonusUrl}/events/preview-email`, body);
  }

  getDetails(params: any = {}): Observable<BaseResponse<SentStatusMailResponse>> {
    return this.http.get<BaseResponse<SentStatusMailResponse>>(`${this.bonusUrl}/list-edit-promotion-notify-email`, { params });
  }

  resendAll(logId: number) {
    return this.http.post(`${this.bonusUrl}/resend-promotion-notify-email-campaign`, {
      logId
    });
  }

  resendOne(id: number) {
    return this.http.post(`${this.bonusUrl}/resend-promotion-notify-email/${id}`, {});
  }

}
